import { NumericBreakpoint } from 'app/constants/Breakpoints';
import { createContext, useContext } from 'react';

/**
 * Helper for creating a breakpoint context
 * @param defaultBreakpoint - The default value for the context.
 * @returns an object containing the new Provider, Consumer, and hook for using the new context.
 */
const makeMeasuredBreakpointContext = (defaultBreakpoint = NumericBreakpoint.ExtraWide) => {
  const context = createContext(defaultBreakpoint);
  const {
    Provider,
    Consumer,
  } = context;

  return ({
    Consumer,
    useContext: () => useContext(context),
    Provider,
  });
};

export const {
  Provider: PageBreakpointProvider,
  useContext: usePageBreakpoint,
} = makeMeasuredBreakpointContext();

export const {
  Provider: DailyNewsBreakpointProvider,
  Consumer: DailyNewsBreakpointConsumer,
  useContext: useDailyNewsBreakpoint,
} = makeMeasuredBreakpointContext();

export const {
  Provider: LessonBreakpointProvider,
  useContext: useLessonBreakpoint,
} = makeMeasuredBreakpointContext();
